<template>
  <l-section :bg-color="bgColor" :no-border="true" data-comp="l-hero">
    <l-grid class="hero">
      <l-grid-item span-desktop="8" span-tablet="11" align-y="end">
        <div class="hero__header">
          <slot name="header"></slot>
        </div>
      </l-grid-item>
      <l-grid-item span-desktop="3" span-tablet="1" span-mobile="0"></l-grid-item>
      <l-grid-item span-desktop="6" span-tablet="10" align-y="start">
        <div class="hero__content">
          <slot name="content"></slot>
        </div>
      </l-grid-item>
      <l-grid-item span-desktop="1" span-tablet="1" span-mobile="1"></l-grid-item>
      <l-grid-item span-desktop="4" span-tablet="8" span-mobile="9" align-y="end">
        <slot name="image"></slot>
      </l-grid-item>
    </l-grid>
  </l-section>
</template>

<script setup>
defineProps({
  bgColor: {
    type: String,
    default: "",
  },
});
</script>

<style lang="scss" scoped>
.hero {
  min-height: fill-available;
  width: 100%;
  padding: 0 var(--container-spacing-x);
  position: relative;

  @include global.breakpoint(tablet-landscape, min) {
    min-height: 100vh;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      left: 50%;
      height: 110px;
      width: 1px;
      background-color: var(--color-txt-secondary);
      animation: linemove 3s infinite;
      transform-origin: top center;
    }
  }

  &__header {
    padding-top: 160px;
    @include global.breakpoint(tablet-landscape, min) {
      padding-top: 200px;
    }
  }

  &__content {
    padding-bottom: 30px;
    @include global.breakpoint(tablet-landscape, min) {
      padding-bottom: 160px;
    }
  }

  @keyframes linemove {
    0% {
      transform: scaleY(0);
    }

    100% {
      transform: scaleY(1);
    }
  }
}
</style>
